import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import Bot from '../entities/flight/bot';


interface BotState extends ListState<Bot> {
    bot: Bot,
    editBot: Bot,


}

class AuxiliaryServiceMutations extends ListMutations<Bot>{

}

class BotModule extends ListModule<BotState, any, Bot>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Bot>(),
        loading: false,
        editAuxiliaryService: new Bot(),
        selectAuxiliaryService: new Bot(),


    }
    actions = {



      
        async setBotStatuses(context: ActionContext<BotState, any>, payload: any) {
            let reponse = await Ajax.post(
                '/api/services/app/Admin/SetBotStatuses',
                payload.data
            );

            let page = reponse.data.result as PageResult<Bot>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;


        },


        async getBotStatuses(context: ActionContext<BotState, any>, payload: any) {

            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/Admin/GetBotStatuses', payload.data);
       
            context.state.loading = false;
            let page = reponse.data.result as Array<Bot>;
            context.state.list = page;


        },




    };
    mutations = {
        setCurrentPage(state: BotState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BotState, pagesize: number) {
            state.pageSize = pagesize;
        },

    }
}
const botModule = new BotModule();
export default botModule;